import { QueryClient } from "@tanstack/react-query";
import { AuthError } from "@/api/Api";

/**
 * Global QueryClient instance, exported so non-React code (e.g. the logout
 * flow in `@/lib/logout`) can clear the cache. Mirrors iOS
 * `client-native/src/hooks/useQueryClient.ts`, which exports `globalQueryClient`
 * for the same reason.
 *
 * Options match iOS: disable automatic refetching and never retry 401s. Without
 * this, a transient 401 during the token-clear/reset window (login.tsx) gets
 * retried and can hard-eject the user to onboarding mid-session.
 */
export const globalQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) =>
        error instanceof AuthError ? false : failureCount < 3,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: (failureCount, error) =>
        error instanceof AuthError ? false : failureCount < 3,
    },
  },
});
